import { IDisposable } from "Global/Base/IDisposable";
import { EventsController } from "Global/Dom/EventsController";
import { Checkbox } from "../../../UI.BaseControls/Checkbox";
import { GenericControl } from "../../../UI.BaseControls/GenericControl";
import { createElement, registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";

export class ClassListGridRow extends HTMLElement implements IDisposable {
    private _checkboxElement: Checkbox;
    private _eventController = new EventsController();
    protected _dataElement: HTMLElement;
    private _isSelected: boolean = false;
    private _isDisposed = false;
    private _value: string;

    public get value(): string {
        return this._value;
    }
    public set value(value) {
        this._value = value;
    }

    public set isSelected(v: boolean) {
        if (this._isSelected == v)
            return;

        this._isSelected = v;
        this.classList.toggle("selected", v);
        if (v)
            this.callEvent("selectedRecordChanged");
    }

    public get isSelected(): boolean {
        return this._isSelected;
    }

    public get isChecked(): boolean {
        return this._checkboxElement.checked;
    }

    public set isChecked(v: boolean) {
        this._checkboxElement.checked = v;
    }

    constructor(self?: any) {
        super();
        self ? self._constructor() : this._constructor(); // polyfill
    }

    protected _constructor(): void {
        this._eventController = new EventsController();
        this.classList.add("class-list-row", "DataRow", "CheckedDataRow");
        this._dataElement = createElement({ classes: ["data"] });
        this.appendChild(this._dataElement);
    }

    private _checkboxChange(): void {
        this.callEvent("change");
    }

    public render(): HTMLElement {
        this._dataElement.appendChild(this._createFirstCell());
        this._dataElement.appendChild(createElement({ type: "td", classes: ["cellContainer"], html: `<span>${this.value}</span>` }));

        return this as HTMLElement;
    }

    protected _createFirstCell(): HTMLElement {
        const checkboxContainer = createElement({ type: "div", classes: "record-control-cell CheckBox" });
        checkboxContainer.tabIndex = -1;

        this._checkboxElement = new Checkbox();
        this._checkboxElement.standardAction = true;
        this._checkboxElement.isNullable = false;
        this._checkboxElement.tabIndex = -1;
        this._checkboxElement.setTabIndexOnInnerElement(-1);
        this._eventController.addListener(this._checkboxElement, "change", () => this._checkboxChange());

        checkboxContainer.appendChild(this._checkboxElement as HTMLElement);

        return checkboxContainer;
    }

    /**
     * Zavolá událost na elementu
     * @param eventName Název události
     * @param detail Podrobnosti události
     * @return Vrátí customEvent
     */
    public callEvent(eventName: string, detail?: any, bubbles: boolean = false, cancelable: boolean = false): CustomEvent {
        return GenericControl.callEvent(this, eventName, detail, bubbles, cancelable);
    }

    public dispose(): void {
        if (this._isDisposed) {
            return;
        }

        if (this._checkboxElement) {
            this._checkboxElement?.dispose();
            this._checkboxElement?.remove();
            this._checkboxElement = null;
        }

        this._eventController.removeAllListeners();
        this._isDisposed = true;
    }
}

registerCustomElement("tsc-ClassListGridRow", ClassListGridRow);
